module.exports = __webpack_public_path__ + "pdf/fiber.e98df01.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/fiber.pdf
// module id = dcq3
// module chunks = 0